import { useCallback, useEffect, useMemo, useState } from 'react';
import { useGetPermissionsQuery } from '../services/edgeApi';

export const useSession = () => {
  const [token, setToken] = useState<string | null>(
    window.localStorage.getItem('token'),
  );
  const hasToken = useMemo(() => {
    return token !== null && token.length > 0;
  }, [token]);

  const { data, isSuccess: isAuthenticated } = useGetPermissionsQuery(
    undefined,
    {
      skip: !hasToken,
    },
  );

  const user = data?.info;
  const permissions = data?.rules ?? [];

  const watchStorage = useCallback(
    (ev: StorageEvent) => {
      if (ev.key !== 'token') return;
      setToken(ev.newValue);
    },
    [token, setToken],
  );

  useEffect(() => {
    window.addEventListener('storage', watchStorage);
    window.addEventListener('local-storage', watchStorage);
    return () => {
      window.removeEventListener('storage', watchStorage);
      window.removeEventListener('local-storage', watchStorage);
    };
  }, [watchStorage]);

  return { isAuthenticated, hasToken, user, permissions };
};
